import { useTranslation } from 'react-i18next';

export function useAdminMatrixChannelFormTranslations() {
  const { t } = useTranslation();

  const getTranslation = (key: string, interpolationValues?: Record<string, unknown>) =>
    t(`admin_matrix_channel_form.${key}`, interpolationValues);

  const requiredError = (key: string) =>
    getTranslation('errors.required', { field: getTranslation(key) });

  const rangeError = (min: number, max: number) => getTranslation('errors.range', { min, max });

  return { getTranslation, requiredError, rangeError };
}
